import {inject, Injectable} from '@angular/core';
import {BaseModalApiService} from "../../../../../../../core/components/modals/services/base-modal-api.service";
import {ProductCardApiService} from "../../../../services-api/product-card-api.service";
import {RecordTableApiService} from "../../../../../../../core/services-api/record-table-api.service";
import {GetDataInModalParams} from "../../../../types/product-card-modals.types";
import {RecordUpdateRequestParams} from "../../../../../../../core/types/records-table.types";
import {CreateTurnkeyCostData, TurnkeyCostData} from "../types/tp-turnkey-cost-modal,types";
import {TpTurnkeyCostPathStateService} from "./tp-turnkey-cost-path-state.service";
import {
  AttachProductCardFileParams,
  DeleteFileParams,
  GetFilesParams
} from "../../../../types/product-card-files.types";
import {ProductCardFilesApiService} from "../../../../services-api/product-card-files-api.service";
import {TurnkeyCostFile} from "../types/turnkey-cost-file.types";

@Injectable({
  providedIn: 'root'
})
export class TpTurnkeyCostService {
  private baseModalApiService: BaseModalApiService = inject(BaseModalApiService);
  private productCardApiService: ProductCardApiService = inject(ProductCardApiService);
  private recordTableApiService: RecordTableApiService = inject(RecordTableApiService);
  private tpTurnkeyCostPathStateService: TpTurnkeyCostPathStateService = inject(TpTurnkeyCostPathStateService);
  private productCardFilesApiService: ProductCardFilesApiService = inject(ProductCardFilesApiService);

  public createTurnkeyCost(createTurnkeyCostData: CreateTurnkeyCostData): Promise<TurnkeyCostData> {
    return new Promise((resolve, reject) => {
      this.baseModalApiService.createDataInModal<CreateTurnkeyCostData, TurnkeyCostData>(createTurnkeyCostData, this.tpTurnkeyCostPathStateService.pathState()).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public getDataInModal<T>(getDataInModalParams: GetDataInModalParams): Promise<Array<T>> {
    return new Promise((resolve, reject) => {
      this.productCardApiService.fetchDataInModal<T>(getDataInModalParams).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public updatedRecordField<T>(recordUpdateRequestParams: RecordUpdateRequestParams): Promise<T> {
    return new Promise((resolve, reject) => {
      this.recordTableApiService.updateRecord<T>(recordUpdateRequestParams).subscribe({
        next: (recordData: T) => resolve(recordData),
        error: (error) => reject(error)
      });
    });
  }

  public deleteData(path: string, recordId: string | number): Promise<void> {
    return new Promise((resolve, reject) => {
      this.recordTableApiService.deleteRecord(path, recordId).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      });
    });
  }

  public getFiles(getFilesParams: GetFilesParams): Promise<Array<TurnkeyCostFile>> {
    return new Promise((resolve, reject) => {
      this.productCardFilesApiService.fetchFiles<TurnkeyCostFile>(getFilesParams).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public deleteFile(deleteFileParams: DeleteFileParams): Promise<void> {
    return new Promise((resolve, reject) => {
      this.productCardFilesApiService.deleteFile(deleteFileParams).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      });
    });
  }

  public attachFile<T>(attachProductCardFileParams: AttachProductCardFileParams): Promise<T> {
    return new Promise((resolve, reject) => {
      this.productCardFilesApiService.attachFile<T>(attachProductCardFileParams).subscribe({
        next: (data: T) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }
}
